import { gql } from '@apollo/client';

import { Student } from '../../types';
import { studentFragment } from '../fragments';

export interface GetStudentByIdQueryVariables {
  courseId: string;
  studentId: string;
}

export interface GetStudentByIdQueryResult {
  student: Student;
}

export const getStudentByIdQuery = gql`
  query GetStudentByIdQuery($courseId: String!, $studentId: String!) {
    student(courseId: $courseId, studentId: $studentId) @rest(type: "Student", path: "courses/{args.courseId}/students/{args.studentId}") {
      ...Student
    }
  }
  ${studentFragment}
`;
